import { html } from 'lit';
import { File } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-file')
export class PdsIconFile extends PdsIcon {
  @state()
  icon = File;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
